import scrollama, { ScrollamaInstance } from "scrollama";

export function makeScroller(
  scrollItemClass: string,
  scrollStepClass: string
): ScrollamaInstance {
  const scroller = scrollama();

  const scrolly = document.querySelector(scrollItemClass) as Element;
  const scrollySteps = scrolly.querySelectorAll(scrollStepClass);

  scroller.setup({ step: scrollySteps, offset: 0.8 });
  return scroller;
}
